import styled from 'styled-components';

import { H1, Description } from '~/src/ui/typography';

export const RootLayout = styled.div`
padding: 32px 0;

@media (min-width: 320px) {
  max-width: 320px;
}

@media (min-width: 480px) {
  max-width: 480px;
}

@media (min-width: 640px) {
  max-width: 640px;
}

@media (min-width: 960px) {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 960px;
  max-height: 1400px;
}

@media (min-width: 1200px) {
  max-width: 1200px;
  padding: 56px 0;
}
`;

export const RootWrapper = styled.div`
  padding: 20px;

  @media (max-width: 1200px) {
    padding: 16px 10px 0;
  }

  @media (max-width: 480px) {
    }
`;

export const RootPicture = styled.div`
  display: none;
  width: 100%;
  align-items: flex-end;
  align-items: center;

  @media (min-width: 960px) {
    display: block;
  }

  @media (max-width: 1199px) {
    height: 400px;
  }
`;

export const RootSuccess = styled.div`
  @media(max-width: 479px) {
    padding: 0 10px;
  }

  @media (min-width: 960px) {
    width: 58.3333%;
    padding-bottom: 56px;
  }

  @media (min-width: 1200px) {
    width: 50%;
    padding-bottom: 122px;
  }

  & ${H1} {
    margin-bottom: 16px;

    @media (min-width: 960px) {
      margin-bottom: 4px;
    }
  }

  & ${Description} {
    margin-bottom: 32px;

    @media (min-width: 1200px) {
      margin-bottom: 40px;
    }
  }
`;

export const RootSuccessPicture = styled.div`
  @media (min-width: 960px) {
    width: 41.6666%;
  }
`;

RootLayout.displayName = 'RootLayout';
RootWrapper.displayName = 'RootWrapper';
RootPicture.displayName = 'RootPicture';
RootSuccess.displayName = 'RootSuccess';
